import GPT from '@op/components/GPT'; 
import { GPT_TRIGGER_AGENT } from '@op/components/GPT/constants';
import React from 'react';

export default function TriggerModalSelect({
  gptType,
  setGptType,
}: {
  gptType: any;
  setGptType: (value: any) => void;
}) {
  return (
    <GPT.AgentOptionsForm
      hasAgent
      label="Topic Tagging Model"
      options={GPT_TRIGGER_AGENT}
      gptType={gptType}
      setGptType={(value) => {
        setGptType(value);
      }}
    ></GPT.AgentOptionsForm>
  );
}
